<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>区域名称：</p>
        <el-input v-model="condition.name" size="mini" style="width:150px" placeholder="请输入区域名称"/>
      </div>
      <!-- <div class="navContainer" style="width: 230px">
        <p>标识：</p>
        <el-input v-model="condition.identification" size="mini" style="width:150px" placeholder="请输入标识"/>
      </div> -->
      <div class="navContainer" style="width: 230px">
        <p>类型：</p>
        <el-select v-model="condition.level" size="mini" filterable style="width:150px" placeholder="请选中类型">
          <el-option v-for="item in levelOption" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="exportClick" style="cursor:pointer;font-size: 16px;">导出数据</span>
        </div>
        <el-table
          v-loading="tableLoad"
          :data="TableData"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" type="index" width="50px"/>
          <el-table-column prop="adCode" label="区域编码" align="center" min-width="100"/>
          <el-table-column prop="name" label="区域名称" align="center"/>
          <el-table-column prop="parentNameLis" label="区域全称" align="center" min-width="180"/>
          <!-- <el-table-column prop="identification" label="标识" align="center" min-width="100"/> -->
          <el-table-column prop="level" label="区域类型" align="center" min-width="60">
            <div slot-scope="scope">{{getLevel(scope.row.level)}}</div>
          </el-table-column>
          <!-- <el-table-column prop="center" label="经纬度" min-width="160" align="center"/> -->
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <div style="align-items:center;">
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="danger" @click="deleteClick(scope.row.adCode)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{condition.total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="condition.total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :close-on-click-modal="false" :show.sync="dialogVisible" width="550" @close="dialogClose">
        <div class="dialogContainer">
          <el-form :model="form" ref="formRef" label-width="100px" :rules="rules">
            <el-form-item prop="coding" label="区域编码：">
              <el-input v-model="form.coding" :disabled="dialogTitle=='修改'" placeholder="请输入区域编码" autocomplete="off" size="mini"/>
            </el-form-item>
            <el-row>
              <el-col :span="14">
                <el-form-item prop="type" label="区域类型：">
                  <el-select v-model="form.type" :disabled="dialogTitle=='修改'" filterable size="mini" style="width:100%" @change="typeChange" placeholder="请选择区域类型">
                    <el-option v-for="item in levelOption1" :key="item.id" :label="item.name" :value="item.id" :disabled="item.disabled"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item v-if="form.type!='province'&&form.type!=''" label-width="5px" prop="superior">
                  <el-cascader v-model="form.superior" :disabled="dialogTitle=='修改'" :options="regionList" style="width:100%" :props="{
                    expandTrigger: 'hover',
                    value: 'id',
                    label: 'cityName',
                    children: 'children'}"
                    size="mini" collapse-tags filterable clearable placeholder="请选择上级城市" ref="area"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="area" label="区域名称：">
              <el-input v-model="form.area" placeholder="请输入区域名称" @change="areaVerify" autocomplete="off" size="mini"/>
            </el-form-item>
            <!-- <el-form-item prop="identification" label="标识：">
              <el-input v-model="form.identification" placeholder="请输入标识" autocomplete="off" size="mini"/>
            </el-form-item>
            <el-form-item prop="lngLat" label="坐标：">
              <div @click="showMap">
                <el-input class="map-style" v-model="form.lngLat" disabled placeholder="点击选择坐标" autocomplete="off" size="mini"/>
              </div>
            </el-form-item> -->
            <div class="form-btn">
              <el-button @click="addClick" type="primary" :loading="btnLoad" size="medium">确认</el-button>
              <el-button @click="dialogClose" size="medium">取消</el-button>
            </div>
          </el-form>
        </div>
      </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="坐标" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="form.area"/>
      </popup>
    </transition>
  </div>
</template>

<script>
import { areaAdd,areaPageList,areaUpdate,areaDelete,getSecondLevelArea } from "@/service/basicfile"
import {applicationAreaInfo, login} from "@/service/getData";
import { getSessionStore } from "@/config/mUtils";
import { baseUrl } from '@/config/env'
import webMap from '@/components/map'
import popup from "@/components/popup";

export default {
  components: { webMap,popup },
  data() {
    return {
      condition:{
        name: '',   // 区域名称
        identification:'',  // 标识
        level: '',    // 类型
        page: 1,
        size: 10,
        total: 0,
      },
      // 类型数组
      levelOption: [{id:'',name:'全部'},{id:'province',name:'省'},
        {id:'city',name:'市'},{id:'district',name:'区'}],
      // 类型数组
      levelOption1: [{id:'province',name:'省',disabled: true},
        {id:'city',name:'市'},{id:'district',name:'区'}],
      // 表格加载状态
      tableLoad: false,
      // 表格数据
      TableData: [],
      // 区域数组
      regionList: [],
      // 经纬度弹窗
      mapVisible:false,
      // 新增/修改弹窗显隐控制
      dialogVisible: false,
      // 新增/修改弹窗 标题
      dialogTitle: '',
      // 新增/修改表单数据
      form: {coding:'',type:'',superior:'',area:'',identification:'',lngLat:''},
      // 按钮加载状态
      btnLoad: false,
      // 表单验证
      rules: {
        coding:{ required: true, message: '区域编码不能为空', trigger: 'blur' },
        type:{ required: true, message: '区域类型不能为空', trigger: 'blur' },
        superior:{ required: true, message: '上级城市不能为空', trigger: 'blur' },
        area:{ required: true, message: '区域名称不能为空', trigger: 'blur' },
        lngLat:{ required: true, message: '坐标不能为空', trigger: 'blur' },
        identification:{ required: true, message: '标识不能为空', trigger: 'blur' },
      },
    };
  },
  computed:{
    getLevel(){
      return function(state){
        switch(state) {
          case 'province':
            return '省'
          case 'city':
            return '市'
          case 'district':
            return '区'
        }
      };
    },
  },
  mounted() {
    this._areaPageList();
  },
  methods: {
    // 表格分页查询
    async _areaPageList(){
      const obj = {
        name:this.condition.name,
        level:this.condition.level,
        // identification:this.condition.identification,
        rows:this.condition.size,
        page:this.condition.page,
      }
      const res = await areaPageList(obj);
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableData=res.data.records;
      this.condition.total=res.data.total;
    },
    // 重置
    resetBtn(){
       this.condition = { name: '', identification:'', level: '', page: 1, size: 10, total:0 };
    },
    // 查询
    searchBtn(){
      this.condition.page = 1;
      this._areaPageList();
    },
    // 验证不能为直辖市
    areaVerify(val){
      console.log(val);
      if(val == '北京市' || val == '天津市' || val == '上海市' || val == '重庆市') {
        this.form.area = '';
        return this.$message.error('区域不能为直辖市！');
      }
    },
    // 获取上级城市
    async _getSecondLevelArea(val){
      let obj = {level: val};
      let res = await getSecondLevelArea(obj);
      this.regionList = res.data;
    },
    // 区域类型改变
    typeChange(val){
      this.form.superior = '';
      if(val != ''&&val == 'district'){
        this._getSecondLevelArea('city');
      }
      if(val != ''&&val == 'city'){
        this._getSecondLevelArea('province');
      }
    },
    // 打开经纬度弹窗
    showMap(){
      this.mapVisible = true;
    },
    // 关闭经纬度弹窗
    mapClose(val, lngLat) {
      this.form.lngLat = lngLat[0]+','+lngLat[1];
      this.mapVisible=false;
    },
    // 修改数据大小
    contractSizeChange(sizes){
      this.condition.size=sizes;
      this._areaPageList();
    },
    // 换页
    contractCurrentChange(page){
      this.condition.page=page;
      this._areaPageList();
    },
    // 新增
    addBtn(){
      this.dialogTitle = '新增';
      this.form = {coding:'',type:'',superior:'',area:'',identification:'',lngLat:''};
      this.dialogVisible = true;
    },
    // 修改弹窗
    changeClick(row){
      this.dialogTitle = '修改';
      if(row.level != ''&&row.level == 'district'){
        this._getSecondLevelArea('city');
      }
      if(row.level != ''&&row.level == 'city'){
        this._getSecondLevelArea('province');
      }
      this.form = {
        coding: row.adCode,
        type: row.level,
        superior: row.parentCodeLis?row.parentCodeLis.split('/').slice(0,-1):[],
        area: row.name,
        // identification: row.identification,
        // lngLat: row.center
      }
      this.dialogVisible = true;
    },
    // 新增/修改 —— 确认
    async addClick(){
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let obj = {
            adCode: this.form.coding,
            name: this.form.area,
            // identification: this.form.identification,
            // center: this.form.lngLat,
          }
          if(this.dialogTitle=='新增') {
            obj.level = this.form.type;
            if(this.form.type=='province'){
              obj.parentCode = '100000';
            }else {
              obj.parentCode = this.form.superior[this.form.superior.length-1];
            }
          }
          this.btnLoad = true;
          let res = this.dialogTitle=='新增'?await areaAdd(obj):await areaUpdate(obj);
          this.btnLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this._getAreaList();
          this._areaPageList();
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    // 更新区域数据
    async _getAreaList() {
      let res = await applicationAreaInfo();
      if (res.status === 0) {
        if (res.data) {
          setSessionStore("areaList", res.data);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 取消修改
    dialogClose(){
      this.dialogVisible = false;
      this.form = {coding:'',type:'',superior:'',area:'',identification:'',lngLat:''};
      this.$refs.formRef.resetFields();
    },
    // 删除
    deleteClick(id){
      this.$confirm('确定要删除当前区域吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await areaDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._areaPageList();
      }).catch(() => {});
    },
    // 导出数据
    exportClick(){
      const obj = {
        name:this.condition.name||'',
        level:this.condition.level||'',
        // identification:this.condition.identification||''
      };
        // let token = getSessionStore('token');
        // // &identification=${obj.identification}
        // let url = `${baseUrl}/platform/sys/tArea/exportXls?access_token=${token}&name=${obj.name}&level=${obj.level}`
        // window.location.href = url;
        window.exportExcelGet('/platform/sys/tArea/exportXls', `name=${obj.name}&level=${obj.level}`);
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
      }
    }
    .tableContainerNav {
      text-align: right;
      span {
        color: #3388ff;
        text-decoration: underline;
      }
    }

    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .dialogContainer {
    padding: 20px 30px;
    .form-btn {
      text-align: right;
      margin-top: 20px;
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
::v-deep {
  .map-style input.el-input__inner {
    background: #fff !important;
    border-color: #DCDFE6;
    color: #606266;
  }
}
</style>
